/**
 * Map view → icon component, partagée entre Sidebar et BottomNav.
 *
 * Extrait dans son propre fichier 2026-05-28 (audit finding B1) : avant ce
 * mapping était dupliqué dans Sidebar.tsx et BottomNav.tsx, ce qui obligeait
 * à toucher deux endroits pour ajouter une route. Source unique maintenant.
 *
 * À mettre à jour à chaque ajout d'entrée dans `lib/views.ts > View`.
 */

import {
  IconDashboard, IconBuilding, IconUser, IconNews, IconCog,
  IconInbox, IconGift, IconLayers, IconEye, IconFile, IconUsers,
  IconMail, IconAtom, IconActivity,
} from './icons';
import type { View } from '../lib/views';

type IconCmp = (p: { className?: string }) => JSX.Element;

export const VIEW_ICON: Record<View, IconCmp> = {
  'investors-directory': IconBuilding,
  founders: IconUser,
  'founders-inbox': IconInbox,
  'non-dilutive': IconGift,
  'brick-pipeline': IconLayers,
  veille: IconEye,
  templates: IconFile,
  leads: IconUsers,
  'email-funnels': IconMail,
  news: IconNews,
  'quantum-companies': IconAtom,
  dashboard: IconDashboard,
  activity: IconActivity,
  settings: IconCog,
};
